/**
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use strict';

/**
 * Iterates over `collection`, passing each key and value to `callback`. If
 * `callback` returns false, the loop will be broken early.
 */
export default function (collection, callback, context) {
    context = context || this;

    for (let key of Object.keys(collection)) {
        let keepGoing = callback.call(context, key, collection[key], collection);
        if (keepGoing === false) {
            break;
        }
    }
}



/** WEBPACK FOOTER **
 ** ./lib/each.es6.js
 **/